import { Box, Typography, Container } from "@mui/material";
import grp from "./../../assets/grp.jpg";
const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function WhoWeAre() {
  const whoWeAreImage =
   grp

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: 5,
          }}
        >
          {/* LEFT - TEXT */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h4"
              fontWeight={700}
              sx={{ color: brandBlue, mb: 3 }}
            >
              Who We Are
            </Typography>
            <Box
              sx={{
                width: "70px",
                height: "4px",
                background: brandRed,
                borderRadius: 2,
                mb: 3,
              }}
            />

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                lineHeight: 1.7,
                fontSize: "1.1rem",
              }}
            >
              We are a team of passionate engineers, technicians, fabricators, welders, and industry specialists dedicated to precision, craftsmanship, and reliability.
              <br />
              Backed by decades of expertise in acoustic engineering, metal fabrication, fuel systems, and industrial structural works, we deliver end-to-end solutions — from design and prototyping to production and installation.
              <br />
              Our culture is built on: <br />
              ✔ Engineering integrity<br />
              ✔ Customer-focused solutions<br />
              ✔ Precision in every detail<br />
              ✔ Continual improvement<br />
            </Typography>
          </Box>

          {/* RIGHT - IMAGE */}
          <Box
            sx={{
              flex: 1,
              borderRadius: 3,
              overflow: "hidden",
              //   minHeight: { xs: "250px", md: "350px" },
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src={whoWeAreImage}
              alt="Who We Are"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
